module.exports = __webpack_public_path__ + "img/home-actions.bd5cda44.svg";